import { Module, ActionContext } from 'vuex'
import { RootState, ScoreProfileState } from './state_models'
import ScoringService from '../services/ScoringService'

export const scoreProfiles: Module<ScoreProfileState, RootState> = {
  namespaced: true,

  state: { profiles: [], locationId: undefined },

  getters: {
    getById: (state: ScoreProfileState) => {
      return (id: string) => state.profiles.find(p => p.id === id)
    },

    getAll: (state: ScoreProfileState) => {
      return state.profiles
    },
  },

  mutations: {
    set: (
      state: ScoreProfileState,
      payload: { profiles: any[]; locationId: string }
    ) => {
      state.profiles = payload.profiles
      if (payload.locationId) {
        state.locationId = payload.locationId
      }
    },

    setProfile: (
      state: ScoreProfileState,
      profile
    ) => {
      state.profiles.forEach((p, i) => {
        if (p.id === profile.id) {
          state.profiles[i] = profile
        }
      })
    },

    clearAll(state: ScoreProfileState) {
      state.profiles = []
      state.locationId = undefined
    },
  },

  actions: {
    async syncAll(
      context: ActionContext<ScoreProfileState, RootState>,
      locationId: string
    ) {
      if (!locationId) {
        context.commit('clearAll')
        return
      }

      if (context.state.locationId === locationId) {
        return context.state.profiles
      }

      try {
        const res = await ScoringService.getProfiles(locationId)
        const profiles = res.map(
          ({ name, _id, description, status, rules, locationId }) => ({ name, id: _id, description, status, rules, locationId })
        )

        context.commit('set', {
          locationId: locationId,
          profiles,
        })
      } catch (err) {
        console.error(err)
        context.commit('clearAll')
      }
    },

    logout: {
      root: true,
      handler: (context: ActionContext<ScoreProfileState, RootState>) => {
        context.commit('clearAll')
      },
    },

    clearAll: {
      handler: (context: ActionContext<ScoreProfileState, RootState>) => {
        context.commit('clearAll')
      },
    },

    setProfile(context: ActionContext<ScoreProfileState, RootState>, payload) {
      context.commit('setProfile', payload)
    },
  },
}
